import { useMe } from './api';
import { useWorkspaceStore } from '@/stores/workspace';
import type { WorkspaceSummary } from '@wrapforce/shared';

export function useActiveMembership(): { membership: WorkspaceSummary | undefined; isLoading: boolean } {
  const { data: me, isLoading } = useMe();
  const activeWorkspaceId = useWorkspaceStore((s) => s.activeWorkspaceId);
  const membership = me?.memberships.find((m) => m.workspaceId === activeWorkspaceId);
  return { membership, isLoading };
}
